import { dec, formatHours, formatQuantity, type Unit } from '@siteday/shared';

export { formatHours, formatQuantity };

/** "$13,860" from a decimal string; no cents unless present. */
export function formatMoney(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  const d = dec(value);
  const whole = d.toDecimalPlaces(0).toNumber();
  return `$${whole.toLocaleString('en-US')}`;
}

/** "2,400" or "—" for null. */
export function qty(value: string | number | null | undefined, unit?: Unit | string): string {
  if (value === null || value === undefined || value === '') return '—';
  return unit ? `${formatQuantity(value)} ${unit}` : formatQuantity(value);
}

/** Hours for tables: "10.0", or "—" when nothing. */
export function hrs(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  return formatHours(value);
}

/** "$42.00" for hourly costs. */
export function formatRate(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  return dec(value).toFixed(2);
}

export function formatPct(pct: number | null | undefined): string {
  return pct === null || pct === undefined ? '—' : `${pct}%`;
}

/** "45 min" / "4 h" / "4 h 30 min". */
export function formatMinutes(minutes: number | null | undefined): string {
  if (minutes === null || minutes === undefined) return '—';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m} min`;
  if (m === 0) return `${h} h`;
  return `${h} h ${m} min`;
}

/** "(615) 555-0101" from E.164 when it is a US number, else as-is. */
export function formatPhone(phone: string | null | undefined): string {
  if (!phone) return '—';
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(phone);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : phone;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
}

export function plural(n: number, one: string, many = `${one}s`): string {
  return `${n} ${n === 1 ? one : many}`;
}
